export const setVideoLinksWithoutCookie = (link) => {
  if (!link.includes("youtube")) return link;
  if (link.includes("youtube.com/watch?v="))
    link = link.replace("youtube.com/watch?v=", "youtube.com/embed/");
  return link.replace("youtube.com", "youtube-nocookie.com");
};
